<div class="user-area-wrapper">
  <opac-user-title [title]="'checkoutHistory.title' | translate"></opac-user-title>

  <opac-no-results
    *ngIf="!loading && !userService.checkoutHistory.length"
    [label]="'checkoutHistory.noCheckouts1' | translate">
  </opac-no-results>

  <button
    *ngIf="userService.checkoutHistory.length"
    mat-flat-button
    class="warn transparent delete-all"
    (click)="showDeleteCheckoutHistoryDialog.set(true)">
    {{ 'common.deleteAll' | translate }}
  </button>
  <div *ngIf="userService.checkoutHistory.length" class="user-content-wrapper">
    <app-user-checkout-history-item
      *ngFor="let checkout of userService.checkoutHistory"
      [checkout]="checkout"
      (removed)="onRemoved($event)"></app-user-checkout-history-item>
  </div>

  <div class="user-checkout-history__more" *ngIf="hasLoadMore" opacViewportObserver (visible)="loadMore()">
    <button mat-flat-button class="accent" (click)="loadMore()" [class.waiting]="waiting">
      <ng-container *ngIf="waiting"> {{ 'results.suggestions.moreResults' | translate }} </ng-container>

      <mat-spinner *ngIf="waiting" [diameter]="30"></mat-spinner>
    </button>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'common.accept'"
  [open]="showDeleteCheckoutHistoryDialog()"
  [title]="'common.deleteAll' | translate"
  (accept)="deleteAll()"
  (cancel)="showDeleteCheckoutHistoryDialog.set(false)">
  <p>{{'messages.checkoutHistory.confirmRemoveAll' | translate }}</p>
</opac-confirmation-dialog>
